import React from "react";
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { BsArrowRight } from 'react-icons/bs';

import './modal.css';

const Modal = ({onClose}) => {

  return (
    <section id="modal_cadastro">
      <div className="modal_insert">
        <form
          method="POST"
          action="sendmail.php"
          className="form-insert"
        >
          <div className="header_form">
            <AiOutlineCloseCircle onClick={onClose}/>
          </div>

          <div className="firstLine">
            <input
              className="name"
              name="name"
              type="text"
              placeholder="Nome Completo*"
              required="required"
            />
          </div>

          <div className="secondline">
            <input
              className="birthDate"
              name="birthDate"
              type="text"
              placeholder="Data de Nascimento*"
              required="required"
            />
            <input
              className="nacionality"
              name="nacionality"
              type="text"
              placeholder="Nacionalidade*"
              required="required"
            />
          </div>

          <div className="thirdline">
            <input
              className="email"
              name="email"
              type="email"
              placeholder="Email*"
              required="required"
            />
            <input
              className="nif"
              name="nif"
              type="text"
              placeholder="Nº CC/Passaporte*"
              required="required"
            />
          </div>

          <div className="fifthline">
            <input
              className="phone"
              name="phone"
              type="text"
              placeholder="Telemóvel"
            />
            <div className="select">
              <select className="options" name="turno" id="turno" required>
                <option className="opt" disabled={true} value="" selected>
                  Turno
                </option>
                <option className="opt" value="1turno">
                  1ºTurno
                </option>
                <option className="opt" value="2turno">
                  2ºTurno
                </option>
              </select>
            </div>
          </div>

          <div className="fourthline">
            <div className="selection">
              <div className="input1">
                <input
                  className="rgpg1"
                  name="rgpd1"
                  type="checkbox"
                  id="rgpd1"
                  required="required"
                />
                <label htmlFor="rgpd1">
                  Autorizo o tratamento dos meus dados pessoais pela APA -
                  Administração do Porto de Aveiro efeito da inscrição*
                </label>
              </div>
              <div className="input2">
                <input
                  className="rgpg1"
                  name="rgpd2"
                  type="checkbox"
                  id="rgpd2"
                  required="required"
                />
                <label htmlFor="rgpd2">
                  Autorizo a captação e utilização de imagens durante a visita
                  pela APA - Administração do Porto de Aveiro efeito da
                  inscrição*
                </label>
              </div>
            </div>
          </div>

          <div className="obg">
            <p className="caution">*Campos de preenchimento obrigatório. </p>
          </div>

          <div className="btn_form">
            <button type="submit" className="submit_form">SUBMETER &nbsp;<BsArrowRight /></button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Modal;
